var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFixedDepositIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 659,
    height: 385,
    viewBox: "0 0 659 385",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M185.1 300.987C228.721 300.987 264.083 292.904 264.083 282.933C264.083 272.963 228.721 264.88 185.1 264.88C141.478 264.88 106.116 272.963 106.116 282.933C106.116 292.904 141.478 300.987 185.1 300.987Z",
    stroke: "#2D5F3F",
    strokeWidth: 1.6925
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M185.1 296.473C222.49 296.473 252.8 290.411 252.8 282.933C252.8 275.455 222.49 269.393 185.1 269.393C147.711 269.393 117.4 275.455 117.4 282.933C117.4 290.411 147.711 296.473 185.1 296.473Z",
    stroke: "#2D5F3F",
    strokeWidth: 1.12833
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M185.1 287.447C187.593 287.447 189.614 285.426 189.614 282.933C189.614 280.441 187.593 278.42 185.1 278.42C182.608 278.42 180.587 280.441 180.587 282.933C180.587 285.426 182.608 287.447 185.1 287.447Z",
    fill: "#2D5F3F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M185.1 266.008C227.475 266.008 261.826 258.431 261.826 249.083C261.826 239.736 227.475 232.158 185.1 232.158C142.725 232.158 108.373 239.736 108.373 249.083C108.373 258.431 142.725 266.008 185.1 266.008Z",
    stroke: "#2D5F3F",
    strokeWidth: 1.6925
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M185.1 261.495C221.243 261.495 250.543 255.938 250.543 249.083C250.543 242.229 221.243 236.672 185.1 236.672C148.956 236.672 119.656 242.229 119.656 249.083C119.656 255.938 148.956 261.495 185.1 261.495Z",
    stroke: "#2D5F3F",
    strokeWidth: 1.12833
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M185.1 253.032C187.281 253.032 189.049 251.264 189.049 249.083C189.049 246.902 187.281 245.134 185.1 245.134C182.918 245.134 181.15 246.902 181.15 249.083C181.15 251.264 182.918 253.032 185.1 253.032Z",
    fill: "#2D5F3F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M185.1 231.03C226.229 231.03 259.57 223.957 259.57 215.233C259.57 206.509 226.229 199.437 185.1 199.437C143.971 199.437 110.63 206.509 110.63 215.233C110.63 223.957 143.971 231.03 185.1 231.03Z",
    stroke: "#2D5F3F",
    strokeWidth: 1.6925
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M185.1 226.517C219.997 226.517 248.286 221.465 248.286 215.233C248.286 209.002 219.997 203.95 185.1 203.95C150.203 203.95 121.913 209.002 121.913 215.233C121.913 221.465 150.203 226.517 185.1 226.517Z",
    stroke: "#2D5F3F",
    strokeWidth: 1.12833
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M185.1 219.183C187.281 219.183 189.049 217.414 189.049 215.233C189.049 213.052 187.281 211.284 185.1 211.284C182.918 211.284 181.15 213.052 181.15 215.233C181.15 217.414 182.918 219.183 185.1 219.183Z",
    fill: "#2D5F3F"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M185.1 198.308C224.982 198.308 257.313 191.741 257.313 183.64C257.313 175.539 224.982 168.972 185.1 168.972C145.218 168.972 112.887 175.539 112.887 183.64C112.887 191.741 145.218 198.308 185.1 198.308Z",
    stroke: "#2D5F3F",
    strokeWidth: 1.6925
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M185.1 193.795C218.751 193.795 246.03 189.248 246.03 183.64C246.03 178.031 218.751 173.485 185.1 173.485C151.449 173.485 124.17 178.031 124.17 183.64C124.17 189.248 151.449 193.795 185.1 193.795Z",
    stroke: "#2D5F3F",
    strokeWidth: 1.12833
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M185.1 187.025C186.969 187.025 188.485 185.509 188.485 183.64C188.485 181.77 186.969 180.255 185.1 180.255C183.23 180.255 181.715 181.77 181.715 183.64C181.715 185.509 183.23 187.025 185.1 187.025Z",
    fill: "#2D5F3F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M185.1 167.843C223.736 167.843 255.057 161.781 255.057 154.303C255.057 146.825 223.736 140.763 185.1 140.763C146.464 140.763 115.144 146.825 115.144 154.303C115.144 161.781 146.464 167.843 185.1 167.843Z",
    stroke: "#2D5F3F",
    strokeWidth: 1.6925
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M185.1 163.33C217.504 163.33 243.773 159.289 243.773 154.303C243.773 149.318 217.504 145.277 185.1 145.277C152.696 145.277 126.427 149.318 126.427 154.303C126.427 159.289 152.696 163.33 185.1 163.33Z",
    stroke: "#2D5F3F",
    strokeWidth: 1.12833
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M185.1 157.688C186.969 157.688 188.485 156.173 188.485 154.303C188.485 152.434 186.969 150.918 185.1 150.918C183.23 150.918 181.715 152.434 181.715 154.303C181.715 156.173 183.23 157.688 185.1 157.688Z",
    fill: "#2D5F3F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M185.1 139.635C222.49 139.635 252.8 134.078 252.8 127.223C252.8 120.368 222.49 114.812 185.1 114.812C147.711 114.812 117.4 120.368 117.4 127.223C117.4 134.078 147.711 139.635 185.1 139.635Z",
    stroke: "#2D5F3F",
    strokeWidth: 1.6925
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M185.1 135.122C216.258 135.122 241.517 131.585 241.517 127.223C241.517 122.861 216.258 119.325 185.1 119.325C153.942 119.325 128.684 122.861 128.684 127.223C128.684 131.585 153.942 135.122 185.1 135.122Z",
    stroke: "#2D5F3F",
    strokeWidth: 1.12833
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M185.1 130.044C186.658 130.044 187.921 128.781 187.921 127.223C187.921 125.665 186.658 124.402 185.1 124.402C183.542 124.402 182.279 125.665 182.279 127.223C182.279 128.781 183.542 130.044 185.1 130.044Z",
    fill: "#2D5F3F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M117.4 127.223L106.116 282.933",
    stroke: "#2D5F3F",
    strokeWidth: 1.12833
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M252.8 127.223L264.083 282.933",
    stroke: "#2D5F3F",
    strokeWidth: 1.12833
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M365.634 282.933V124.967",
    stroke: "#2D5F3F",
    strokeWidth: 1.12833
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M365.634 282.933H568.734",
    stroke: "#2D5F3F",
    strokeWidth: 1.12833
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M365.634 282.933C395.723 275.411 418.289 264.128 433.334 249.083C448.378 234.039 470.945 215.233 501.034 192.667C531.123 170.1 553.689 155.055 568.734 147.533",
    stroke: "#2D5F3F",
    strokeWidth: 2.25667,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M365.633 286.318C367.503 286.318 369.018 284.803 369.018 282.933C369.018 281.064 367.503 279.548 365.633 279.548C363.764 279.548 362.248 281.064 362.248 282.933C362.248 284.803 363.764 286.318 365.633 286.318Z",
    fill: "#2D5F3F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M410.767 269.393C412.636 269.393 414.152 267.878 414.152 266.008C414.152 264.139 412.636 262.623 410.767 262.623C408.897 262.623 407.382 264.139 407.382 266.008C407.382 267.878 408.897 269.393 410.767 269.393Z",
    fill: "#2D5F3F"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M455.9 235.543C457.769 235.543 459.285 234.028 459.285 232.158C459.285 230.289 457.769 228.773 455.9 228.773C454.03 228.773 452.515 230.289 452.515 232.158C452.515 234.028 454.03 235.543 455.9 235.543Z",
    fill: "#2D5F3F"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M501.033 196.051C502.903 196.051 504.418 194.536 504.418 192.666C504.418 190.797 502.903 189.281 501.033 189.281C499.164 189.281 497.648 190.797 497.648 192.666C497.648 194.536 499.164 196.051 501.033 196.051Z",
    fill: "#2D5F3F"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M546.166 162.202C548.036 162.202 549.551 160.686 549.551 158.817C549.551 156.947 548.036 155.432 546.166 155.432C544.297 155.432 542.781 156.947 542.781 158.817C542.781 160.686 544.297 162.202 546.166 162.202Z",
    fill: "#2D5F3F"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M365.634 243.442H568.734",
    stroke: "#2D5F3F",
    strokeWidth: 0.564167,
    strokeDasharray: "3.38 3.38"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M365.634 203.95H568.734",
    stroke: "#2D5F3F",
    strokeWidth: 0.564167,
    strokeDasharray: "3.38 3.38"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M365.634 164.458H568.734",
    stroke: "#2D5F3F",
    strokeWidth: 0.564167,
    strokeDasharray: "3.38 3.38"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M416.408 282.933V288.575",
    stroke: "#2D5F3F",
    strokeWidth: 0.902667
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M467.184 282.933V288.575",
    stroke: "#2D5F3F",
    strokeWidth: 0.902667
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M517.958 282.933V288.575",
    stroke: "#2D5F3F",
    strokeWidth: 0.902667
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M568.733 282.933V288.575",
    stroke: "#2D5F3F",
    strokeWidth: 0.902667
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M568.733 147.533L602.583 119.325",
    stroke: "#2D5F3F",
    strokeWidth: 1.6925
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M602.583 119.325L596.942 127.223L593.557 118.197L602.583 119.325Z",
    fill: "#2D5F3F"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M546.167 164.458C549.283 164.458 551.809 161.932 551.809 158.816C551.809 155.701 549.283 153.175 546.167 153.175C543.051 153.175 540.525 155.701 540.525 158.816C540.525 161.932 543.051 164.458 546.167 164.458Z",
    fill: "#2D5F3F"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M546.167 168.972C551.775 168.972 556.322 164.425 556.322 158.817C556.322 153.208 551.775 148.662 546.167 148.662C540.558 148.662 536.012 153.208 536.012 158.817C536.012 164.425 540.558 168.972 546.167 168.972Z",
    stroke: "#2D5F3F",
    strokeWidth: 1.12833
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M151.25 79.8333C163.713 79.8333 173.817 69.7298 173.817 57.2666C173.817 44.8034 163.713 34.7 151.25 34.7C138.787 34.7 128.684 44.8034 128.684 57.2666C128.684 69.7298 138.787 79.8333 151.25 79.8333Z",
    stroke: "#2D5F3F",
    strokeWidth: 1.12833
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M152.134 61.5213V60.8289C152.134 60.3503 152.232 59.9122 152.429 59.5147C152.63 59.1129 152.92 58.7924 153.301 58.5531C153.686 58.3094 154.151 58.1876 154.698 58.1876C155.254 58.1876 155.72 58.3094 156.096 58.5531C156.472 58.7924 156.756 59.1129 156.949 59.5147C157.141 59.9122 157.237 60.3503 157.237 60.8289V61.5213C157.237 62 157.139 62.4402 156.942 62.842C156.75 63.2395 156.464 63.56 156.083 63.8036C155.707 64.043 155.246 64.1627 154.698 64.1627C154.143 64.1627 153.675 64.043 153.294 63.8036C152.914 63.56 152.626 63.2395 152.429 62.842C152.232 62.4402 152.134 62 152.134 61.5213ZM153.442 60.8289V61.5213C153.442 61.9188 153.536 62.2757 153.724 62.592C153.912 62.904 154.237 63.06 154.698 63.06C155.147 63.06 155.463 62.904 155.647 62.592C155.835 62.2757 155.929 61.9188 155.929 61.5213V60.8289C155.929 60.4315 155.84 60.0767 155.66 59.7647C155.481 59.4485 155.16 59.2903 154.698 59.2903C154.25 59.2903 153.927 59.4485 153.73 59.7647C153.538 60.0767 153.442 60.4315 153.442 60.8289ZM145.595 54.0077V53.3153C145.595 52.8366 145.693 52.3985 145.89 52.001C146.091 51.5993 146.381 51.2787 146.762 51.0394C147.146 50.7958 147.612 50.6739 148.159 50.6739C148.715 50.6739 149.181 50.7958 149.557 51.0394C149.933 51.2787 150.217 51.5993 150.409 52.001C150.602 52.3985 150.698 52.8366 150.698 53.3153V54.0077C150.698 54.4863 150.6 54.9266 150.403 55.3283C150.211 55.7258 149.924 56.0464 149.544 56.29C149.168 56.5293 148.706 56.649 148.159 56.649C147.604 56.649 147.136 56.5293 146.755 56.29C146.375 56.0464 146.086 55.7258 145.89 55.3283C145.693 54.9266 145.595 54.4863 145.595 54.0077ZM146.903 53.3153V54.0077C146.903 54.4051 146.997 54.762 147.185 55.0783C147.373 55.3903 147.698 55.5463 148.159 55.5463C148.608 55.5463 148.924 55.3903 149.108 55.0783C149.296 54.762 149.39 54.4051 149.39 54.0077V53.3153C149.39 52.9178 149.3 52.5631 149.121 52.2511C148.941 51.9348 148.621 51.7766 148.159 51.7766C147.71 51.7766 147.388 51.9348 147.191 52.2511C146.999 52.5631 146.903 52.9178 146.903 53.3153ZM146.082 63.9832L155.109 50.8535H156.57L147.544 63.9832H146.082Z",
    fill: "#2D5F3F"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M558.578 79.8333H533.755C531.262 79.8333 529.241 81.8539 529.241 84.3466V103.528C529.241 106.021 531.262 108.042 533.755 108.042H558.578C561.071 108.042 563.091 106.021 563.091 103.528V84.3466C563.091 81.8539 561.071 79.8333 558.578 79.8333Z",
    stroke: "#2D5F3F",
    strokeWidth: 1.354
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M537.14 79.8332V70.8065C537.14 65.541 540.149 62.9082 546.166 62.9082C552.184 62.9082 555.193 65.541 555.193 70.8065V79.8332",
    stroke: "#2D5F3F",
    strokeWidth: 1.354
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M546.166 97.8867C548.036 97.8867 549.551 96.3712 549.551 94.5017C549.551 92.6322 548.036 91.1167 546.166 91.1167C544.297 91.1167 542.781 92.6322 542.781 94.5017C542.781 96.3712 544.297 97.8867 546.166 97.8867Z",
    fill: "#2D5F3F"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M72.267 384.483C90.9618 384.483 106.117 369.328 106.117 350.633C106.117 331.938 90.9618 316.783 72.267 316.783C53.5722 316.783 38.417 331.938 38.417 350.633C38.417 369.328 53.5722 384.483 72.267 384.483Z",
    stroke: "#2D5F3F",
    strokeWidth: 0.902667
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFixedDepositIllustration);
export default __webpack_public_path__ + "static/media/fixed-deposit-illustration.1f6de70b7d4f931ecd844628d3a3084a.svg";
export { ForwardRef as ReactComponent };